"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UwSpecDefaultPolicyName = void 0;
/**
 * Default Policy Names for Underwriting
 *
 * This enum is the source of truth for default policy names used across
 * both TypeScript and Python. Python's DefaultExperimentName should be
 * replaced with this generated enum.
 *
 * These map to Python's DEFAULT_* constants in policyForExperimentName.py
 *
 * TODO: This was historically created for compositor config use, but is no longer used.
 * Consider whether this is still necessary to expose out of Python.
 *
 * @TranslateToPython
 */
var UwSpecDefaultPolicyName;
(function (UwSpecDefaultPolicyName) {
    UwSpecDefaultPolicyName["default"] = "default";
    UwSpecDefaultPolicyName["defaultUcc"] = "defaultUcc";
    UwSpecDefaultPolicyName["defaultDm"] = "defaultDm";
    UwSpecDefaultPolicyName["defaultHelocRefiFFTRUL"] = "defaultHelocRefiFFTRUL";
    UwSpecDefaultPolicyName["defaultHelocRefiWSJ"] = "defaultHelocRefiWSJ";
    UwSpecDefaultPolicyName["defaultDigitalRefiAvenCashWSJ"] = "defaultDigitalRefiAvenCash";
    UwSpecDefaultPolicyName["defaultDMRefiAvenCashWSJ"] = "defaultDMRefiAvenCashWSJ";
    UwSpecDefaultPolicyName["defaultMortgageRefi"] = "defaultMortgageRefi";
    UwSpecDefaultPolicyName["defaultDeposit"] = "defaultDeposit";
    UwSpecDefaultPolicyName["defaultUccToHomeUpgradePolicyName"] = "defaultUccToHomeUpgradePolicyName";
})(UwSpecDefaultPolicyName || (exports.UwSpecDefaultPolicyName = UwSpecDefaultPolicyName = {}));
